import * as React from "react";

import { connect } from "react-redux";
import { IData } from "../../reducers/dataReducer";
import { IAnaf } from "../../reducers/anafReducer";
import { ScrollHolder } from "../pages/Scrolling";
import MasonryList from "../masonry/MasonryList";

import * as styles from "./artloan.module.css";

interface State {
  path: string;
  randomSet: number[];
}

interface parentProps {
  match: any;
  location: any;
}

interface StoreProps {
  data: IData;
  anaf: IAnaf;
}

interface DispatchProps {
  resetCrumbs: Function;
  addCrumbs: Function;
}

const mapStateToProps = (state) => {
  return {
    anaf: state.anaf,
    data: state.data,
  };
};

const mapDispatchToProps = (dispatch) => ({});

type Props = StoreProps & DispatchProps & parentProps;

export class ArtLoan extends React.Component<Props, State> {
  render() {
    const { data, anaf } = this.props;
    const artworks = data.artworks.byIds;

    const onloan = Object.values(artworks).filter((artwork) => {
      return artwork.on_loan && artwork.published;
    });

    console.log(onloan);
    return (
      <div>
        <ScrollHolder id="content">
          <div className={styles.masonpadding}></div>
          <MasonryList artwork_ids={onloan.map((artwork) => artwork.id)} />
        </ScrollHolder>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArtLoan);
